module.exports = __webpack_public_path__ + "static/media/room-escape.b3873b71.jpeg";